
import BoxTick from "../../../assets/filled/BoxTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BoxTickIcon({ className, dataTestid = "BoxTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BoxTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
